import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";

import LogoLogin from "../../assets/login/logo.jpg";
import OrgChart from "./OrgChart";

const CompanyPdfFormat = () => {
  const employeeList = useSelector(
    (state) => state.companyDetailsReducer.employeeList,
  );
  const companyDetails = useSelector(
    (state) => state.companyDetailsReducer.companyDetails,
  );
  const similarCompanyList = useSelector(
    (state) => state.companyDetailsReducer.similarCompanyList,
  );

  let sdate = new Date();

  return (
    <div
      style={{
        width: "100%",
        fontFamily: "sans-serif",
        fontSize: "14px",
        maxWidth: "180mm",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div
          style={{
            float: "left",
            width: "50%",
            backgroundColor: "#ffffff",
            display: "tableCell",
          }}
        >
          <div
            style={{
              display: "flex",
              margin: "25px -49px 5px",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <div style={{ display: "tableCell", width: "100%" }}>
              <div
                style={{
                  backgroundColor: "#5d44ff",
                  width: "74px",
                  height: "74px",
                  padding: "15px 10px 10px 10px",
                  color: "#fff",
                  fontSize: "21px",
                  fontWeight: "bold",
                  lineHeight: "22px",
                  marginLeft: "50px",
                  marginTop: "5px",
                  boxShadow:
                    "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                }}
              >
                <img src={LogoLogin} alt="" />
              </div>
            </div>
          </div>

          <div style={{ padding: "10px 10px 0 0", marginTop: "10px" }}>
            <div style={{ display: "flex", alignItems: "self-start" }}>
              <div>
                <h1
                  style={{
                    fontSize: "48px",
                    lineHeight: "54px",
                    textAlign: "left",
                    fontWeight: "bolder",
                    fontFamily: "arial",
                    marginBlockStart: "17px",
                    marginBlockEnd: "5px",
                    letterSpacing: "-3px",
                    maxWidth: "300px",
                  }}
                >
                  {companyDetails?.name}
                </h1>
                <h2
                  style={{
                    fontSize: 18,
                    marginBlockStart: "10px",
                    marginBlockEnd: 0,
                    textAlign: "left",
                    maxWidth: "300px",
                  }}
                >
                  {companyDetails?.address}
                </h2>

                <div
                  style={{
                    margin: "10px 0 0 0",
                    color: "#000",
                  }}
                >
                  <div
                    style={{
                      fontSize: 12,
                      marginBottom: "10px",
                      maxWidth: "fit-content",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        marginRight: "0.5em",
                        fontSize: 14,
                        fontWeight: "bolder",
                      }}
                    >
                      Phone
                    </div>
                    <div> {companyDetails?.phoneNo} </div>
                  </div>
                  <div
                    style={{
                      marginBottom: "10px",
                      fontSize: 12,
                      maxWidth: "fit-content",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ marginRight: "0.5em", fontWeight: "bolder" }}>
                      Website
                    </div>
                    <Link
                      style={{ color: "#000", fontWeight: "normal" }}
                      title=""
                      to={`http://${companyDetails?.wedsite}`}
                      target="_blank"
                    >
                      {companyDetails?.wedsite}
                    </Link>
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      maxWidth: "300px",
                    }}
                  >
                    <div
                      style={{
                        marginRight: "0.5em",
                        fontSize: 14,
                        fontWeight: "bolder",
                        paddingBottom: "5px",
                      }}
                    >
                      Description of business
                    </div>
                    <div style={{ textAlign: "justify" }}>
                      {companyDetails?.introduction}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            float: "left",
            width: "40%",
            height: "fit-content",
            backgroundColor: "#fdc401",
            padding: "0 10px",
            color: "#575656",
            display: "tableCell",
            borderRadius: "0 15px 15px 0",
            backgroundImage: "linearGradient(#fdc401, #fff)",
          }}
        >
          <div
            style={{
              padding: "10px",
              marginTop: "10px",
              textAlign: "left",
              fontSize: 12,
              margin: "0 20px 45px 10px",
              color: "#000",
            }}
          >
            Time Stamp:{moment(sdate).utc().format("YYYY-MM-DD HH:MM:SS A")}
          </div>
          <div style={{ padding: "10px", marginTop: "10px" }}>
            <div style={{ margin: "20px 10px" }}>
              <div
                style={{
                  width: "100%",
                  fontSize: "14px",
                  lineHeight: "0.5em",
                  paddingBottom: "10px",
                  fontWeight: "bold",
                  color: "#000",
                  marginTop: "30px",
                  marginBottom: "5px",
                  borderBottom: "1px solid #333",
                }}
              >
                Employees Range
              </div>
              <div style={{ fontSize: "13px", fontWeight: "bold" }}>
                {companyDetails?.range?.name}
              </div>
            </div>

            <div style={{ margin: "20px 10px" }}>
              <div
                style={{
                  width: "100%",
                  fontSize: "14px",
                  lineHeight: "0.5em",
                  paddingBottom: "10px",
                  fontWeight: "bold",
                  color: "#000",
                  marginTop: "30px",
                  marginBottom: "5px",
                  borderBottom: "1px solid #333",
                }}
              >
                Revenue Range
              </div>
              <div style={{ fontSize: "13px", fontWeight: "bold" }}>
                {companyDetails?.revenue?.name}
              </div>
            </div>

            <div style={{ margin: "20px 10px" }}>
              <div
                style={{
                  width: "100%",
                  fontSize: "14px",
                  lineHeight: "0.5em",
                  paddingBottom: "10px",
                  fontWeight: "bold",
                  color: "#000",
                  marginTop: "30px",
                  marginBottom: "5px",
                  borderBottom: "1px solid #333",
                }}
              >
                Company Type
              </div>
              <div style={{ fontSize: "13px", fontWeight: "bold" }}>
                {companyDetails?.category?.name}
              </div>
            </div>

            <div style={{ margin: "20px 10px" }}>
              <div
                style={{
                  width: "100%",
                  fontSize: "14px",
                  lineHeight: "0.5em",
                  paddingBottom: "10px",
                  fontWeight: "bold",
                  color: "#000",
                  marginTop: "30px",
                  marginBottom: "5px",
                  borderBottom: "1px solid #333",
                }}
              >
                Industry{" "}
              </div>
              <div style={{ fontSize: "13px", fontWeight: "bold" }}>
                {companyDetails?.industry?.name}
              </div>
            </div>

            <div style={{ margin: "20px 10px" }}>
              <div
                style={{
                  width: "100%",
                  fontSize: "14px",
                  lineHeight: "0.5em",
                  paddingBottom: "10px",
                  fontWeight: "bold",
                  color: "#000",
                  marginTop: "30px",
                  marginBottom: "5px",
                  borderBottom: "1px solid #333",
                }}
              >
                Technographics
              </div>
              <div style={{ fontSize: "13px", fontWeight: "bold" }}>
                {companyDetails?.technographics}
              </div>
            </div>

            <div style={{ margin: "20px 10px" }}>
              <div
                style={{
                  width: "100%",
                  fontSize: "14px",
                  lineHeight: "0.5em",
                  paddingBottom: "10px",
                  fontWeight: "bold",
                  color: "#000",
                  marginTop: "30px",
                  marginBottom: "5px",
                  borderBottom: "1px solid #333",
                }}
              >
                Updated on
              </div>
              <div style={{ fontSize: 12, fontWeight: "bold" }}>
                {companyDetails?.lastUpdated}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          padding: "20px 0",
          textAlign: "center",
          background: "#fff",
          marginTop: "26px",
          width: "100%",
        }}
      >
        <div
          style={{
            padding: "10px 0",
            marginTop: "35px",
            width: "100%",
          }}
        >
          {!!employeeList?.length && (
            <table
              style={{
                border: "1px solid #d7d3d3",
                fontSize: 11,
                height: "fit-content",
                fontWeight: 550,
                marginBottom: 10,
                width: "180mm",
              }}
              width="100%"
              border="0"
              cellspacing="0"
              cellpadding="0"
            >
              <tr>
                <td>
                  <div
                    style={{
                      backgroundColor: "#5d44ff",
                      color: "#fff",
                      fontSize: 12,
                      padding: "5px",
                      textAlign: "left",
                      fontWeight: "bold",
                      minWidth: 35,
                      height: "100%",
                      whiteSpace: "nowrap",
                    }}
                  >
                    S.No.
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      backgroundColor: "#5d44ff",
                      color: "#fff",
                      padding: "5px",
                      fontSize: 12,
                      textAlign: "left",
                      fontWeight: "bold",
                      height: "100%",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Executive Name
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      backgroundColor: "#5d44ff",
                      color: "#fff",
                      padding: "5px",
                      fontSize: 12,
                      textAlign: "left",
                      fontWeight: "bold",
                      height: "100%",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Designation{" "}
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      backgroundColor: "#5d44ff",
                      color: "#fff",
                      padding: "5px",
                      fontSize: 12,
                      textAlign: "left",
                      fontWeight: "bold",
                      minWidth: 50,
                      height: "100%",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Email
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      backgroundColor: "#5d44ff",
                      color: "#fff",
                      padding: "5px",
                      fontSize: 12,
                      textAlign: "left",
                      fontWeight: "bold",
                      height: "100%",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Phone
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      backgroundColor: "#5d44ff",
                      color: "#fff",
                      padding: "5px",
                      fontSize: 12,
                      textAlign: "left",
                      fontWeight: "bold",
                      minWidth: 60,
                      height: "100%",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Mobile
                  </div>
                </td>
              </tr>

              {employeeList.slice(0, 10).map((item, index) => {
                return (
                  <>
                    <tr>
                      <td
                        style={{
                          padding: "5px",
                          textAlign: "left",
                          minWidth: 35,
                        }}
                      >
                        {index + 1}
                      </td>
                      <td
                        style={{
                          padding: "5px",
                          textAlign: "left",
                          overflow: "linebreak", // Ensures text does not break weirdly
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {item?.fullname
                          ? item.fullname
                          : item.firstname + " " + item.lastname}
                      </td>
                      <td
                        style={{
                          padding: "5px",
                          textAlign: "left",
                        }}
                      >
                        {item?.title}
                      </td>
                      <td
                        style={{
                          padding: "5px",
                          textAlign: "left",
                        }}
                      >
                        {item?.emailId}
                      </td>
                      <td
                        style={{
                          padding: "5px",
                          textAlign: "left",
                        }}
                      >
                        {item?.company?.phoneNo}
                      </td>
                      <td
                        style={{
                          padding: "5px",
                          textAlign: "left",
                        }}
                      >
                        {item?.phoneNo}
                      </td>
                    </tr>
                  </>
                );
              })}
            </table>
          )}
          {employeeList?.length > 10 && (
            <div
              style={{
                color: "#818181",
                fontSize: 10,
                textAlign: "left",
                width: "100%",
              }}
            >
              Download Excel to retrieve all key executive's data.
            </div>
          )}
        </div>
      </div>
      {!!similarCompanyList?.length && (
        <div>
          <h5
            style={{
              width: "fit-content",
              fontSize: "16px",
              lineHeight: "0.5em",
              paddingBottom: "10px",
              fontWeight: "bold",
              color: "#000",
              marginTop: "30px",
              marginBottom: "15px",
              borderBottom: "1px solid #333",
            }}
          >
            Similar Companies
          </h5>
          {similarCompanyList?.map((company) => (
            <div style={{ marginTop: 10 }}>
              <h6 style={{ color: "#373840", fontWeight: "bold" }}>
                {company?.name}
              </h6>
              <div style={{ fontSize: 12 }}>{company?.industry?.name}</div>
              <div style={{ fontSize: 12 }}>{company?.address}</div>
            </div>
          ))}
        </div>
      )}
      <div>
        <h5
          style={{
            width: "fit-content",
            fontSize: "16px",
            lineHeight: "0.5em",
            paddingBottom: "10px",
            fontWeight: "bold",
            color: "#000",
            marginTop: "50px",
            marginBottom: "15px",
            borderBottom: "1px solid #333",
          }}
        >
          Org. Chart
        </h5>
        <OrgChart />
      </div>
    </div>
  );
};

export default CompanyPdfFormat;
